// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../types/index.d.ts" />
import React from 'react';
import { Link } from 'react-router-dom';
import { Badge, Button, Divider, Menu, Tooltip, Tag } from 'antd';
import { MenuProps } from 'antd/lib/menu';
import UserStore from '../../stores/UserStore';
import { observer } from 'mobx-react';
import Icon, { QuestionCircleOutlined, SettingOutlined, FileSyncOutlined } from '@ant-design/icons';
import ThreeD from '../../assets/svg/three-d.svg?react';
import { version } from '../../../package.json';

interface PortalPrivateMenuProps extends MenuProps {
    isDrawer?: boolean;
    onLogout?: () => void;
}

const PrivateMenu = (props: PortalPrivateMenuProps) => {
    return (
        <Menu mode="inline" theme="light" className="h-100" {...props}>
            {props.isDrawer ? <Divider className="my-2" /> : null}
            <Menu.Item key="home">
                <Link to="/my-account">Home</Link>
            </Menu.Item>
            <Menu.Item key="orders">
                <Link to="/my-account/orders">Orders</Link>
            </Menu.Item>
            <Menu.Item key="quotes">
                <Link to="/my-account/quotes">Quotes</Link>
            </Menu.Item>
            <Menu.Item key="parts">
                <Link to="/my-account/parts">
                    <div>
                        <Tag
                            color="#cd2027"
                            style={{
                                height: '0.85rem',
                                fontSize: '10px',
                                fontWeight: 600,
                                lineHeight: '0.85rem',
                                position: 'absolute',
                                top: 0,
                                left: '90px',
                                borderRadius: 10,
                            }}
                        >
                            NEW
                        </Tag>
                        <span> Parts Library</span>
                    </div>
                </Link>
            </Menu.Item>
            <Menu.Item key="invoices">
                <Link to="/my-account/invoices">Invoices</Link>
            </Menu.Item>
            {UserStore.hasAContact && [
                // <Menu.Item key="order-requirements">
                //     <Link to="/my-account/order-requirements">Order Requirements</Link>
                // </Menu.Item>,
                <Menu.Item key="invite">
                    <Link to="/my-account/invite-your-colleagues">Invite your Colleagues</Link>
                </Menu.Item>,
            ]}
            <Divider className="my-1" />
            <Menu.Item key="part-viewer" icon={<Icon component={ThreeD} className="font-size-lg" />}>
                <Link to="/my-account/part-viewer">3D Viewer</Link>
            </Menu.Item>
            {UserStore.user?.is_tester && (
                <Menu.Item key="file-converter" icon={<FileSyncOutlined className="font-size-lg" />}>
                    <Link to="/my-account/file-converter">
                        <div>
                            <Tag
                                color="#cd2027"
                                style={{
                                    height: '0.85rem',
                                    fontSize: '10px',
                                    fontWeight: 600,
                                    lineHeight: '0.85rem',
                                    position: 'absolute',
                                    top: -2,
                                    left: '150px',
                                    borderRadius: 10,
                                }}
                            >
                                NEW
                            </Tag>

                            <span>File Conversion Tool</span>
                        </div>
                    </Link>
                </Menu.Item>
            )}
            <Menu.Item key="file-creation" icon={<FileSyncOutlined className="font-size-lg" />}>
                <Link to="/my-account/file-creation">2D/3D File Creation</Link>
            </Menu.Item>
            <Divider className="my-1" />
            <Menu.Item key="settings" icon={<SettingOutlined />}>
                <Link to="/my-account/settings">Account Settings</Link>
            </Menu.Item>
            <Menu.Item key="support" icon={<QuestionCircleOutlined />}>
                <Link to="/my-account/support">Help & Support</Link>
            </Menu.Item>
            {/* <Divider className="my-1" /> */}
            {/* <a href="https://parts-badger.com" style={{ display: 'block', paddingLeft: '24px', color: '#455560' }}>
                <Button type="link" className="m-0 p-0" icon={<GlobalOutlined className="font-size-md" />}>
                    Main Website
                </Button>
            </a> */}
            {props.isDrawer ? (
                <>
                    <Divider className="my-1" />
                    <Menu.Item key="logout" onClick={props.onLogout}>
                        Logout
                    </Menu.Item>
                </>
            ) : null}
            <div className="text-center mt-4">
                <small className="text-muted">v{version}</small>
            </div>
        </Menu>
    );
};

export default observer(PrivateMenu);
